module.exports = __webpack_public_path__ + "img/slider_text_a1.8275d8c.7981cc42.png";